import WillgoLogo from '../../WillgoLogo.png';
import LOGO_PLACEHOLDER from "../../LOGO_PLACEHOLDER.jpg";

const Type1FooterCard = (props) => {

    const {
        bookingEngine,
        _company_name,
        _logo_url,
    } = props;

    return <div style={{backgroundColor: bookingEngine?.headerBg}} className="bg-white border-t border-slate-200 py-12">
        
          <div style={{textAlign: "center"}}>
            <div className="rounded-md flex items-center justify-center">
                {
                    !bookingEngine?.hideCompanyLogo &&
                    <p style={{display: "flex", flexDirection: "column", justifyContent: "center"}}>
                        <img style={{width: 70, height: 70, borderRadius: `${bookingEngine?.headerLogoBorderRadius}%`}} 
                            src={(_logo_url || LOGO_PLACEHOLDER)}/>
                    </p>
                }
            </div>
            {
                !bookingEngine?.hideCompanyName &&
                <p style={{color: bookingEngine?.headerCompanyTxtColor}} className="text-sm font-bold text-slate-900 tracking-tight">
                    
                        <>
                            {         
                                _company_name ||
                                "Business Name"
                            }
                        </>
                </p>
            }
            <p style={{color: bookingEngine?.headerMenuTxtColor}} className="text-xs font-medium text-slate-700">© {new Date().getFullYear()} {
                    /*!bookingEngine?.hideCompanyName &&*/
                    <>
                        {         
                            _company_name ||
                            "Business Name"
                        }
                    </>
                }. All rights reserved.</p>
          </div>
            
      </div>
}

export default Type1FooterCard;